<template>
    <div style="width: 100%" class="el-table el-table--fit">
        <div id="basicBox" class="el-table__body-wrapper">
            <table width="100%" border="0" cellpadding="0" cellspacing="0" style="width: 100%; border-collapse: collapse" :style="{ height: height + 'px' }">
                <col width="96" span="15" class="xl65" style="mso-width-source: userset; mso-width-alt: 2964" />
                <col width="59" class="xl65" style="mso-width-source: userset; mso-width-alt: 1888" />
                <col width="72" span="240" class="xl65" style="mso-width-source: userset; mso-width-alt: 2304; display: none" />
                <tr height="41.33" style="height: 31pt; mso-height-source: userset; mso-height-alt: 620">
                    <td class="xl66" height="41.33" width="1493" colspan="16" style="height: 31pt; width: 1119.75pt; border: none; font-size: 24pt; text-align: center" x:str>技工学校学生学籍卡</td>
                </tr>
                <tr height="41.33" style="height: 31pt; mso-height-source: userset; mso-height-alt: 620">
                    <td class="xl66" height="41.33" colspan="16" style="height: 31pt; mso-ignore: colspan; border: none"></td>
                </tr>
                <tr height="34.67" style="height: 26pt; mso-height-source: userset; mso-height-alt: 520">
                    <td class="xl67" colspan="3" height="34.67" style="height: 26pt; border: none; text-align: left" x:str>
                        主管部门名称：
                        <template>
                            {{ vo.mainDept || '无' }}
                        </template>
                    </td>
                    <td class="xl67" colspan="3" style="border: none; text-align: left" x:str>
                        学校名称：
                        <span style="padding-left: 5px; text-align: left">{{ vo.orgName }}</span>
                    </td>
                    <td class="xl67" colspan="3" style="border: none; text-align: left" x:str>
                        专业：
                        <span style="padding-left: 5px">{{ vo.majorSubcategory?vo.majorSubcategory:vo.majorSubcategory }}</span>
                    </td>
                    <td class="xl67" colspan="2" style="border: none; text-align: left" x:str>
                        班级：
                        <span style="padding-left: 5px">{{ vo.className?vo.className:vo.className }}</span>
                    </td>
                    <td class="xl67" colspan="2" style="border: none; text-align: left" x:str>
                        学制：
                        <span style="padding-left: 5px">{{ vo.educationSystem }}</span>
                    </td>
                    <td class="xl109" colspan="3" style="border: none; text-align: left">
                        学生证编号：
                        <span style="padding-left: 5px">{{ vo.studentId }}</span>
                    </td>
                </tr>
                <tr height="34.67" style="height: 26pt; mso-height-source: userset; mso-height-alt: 520">
                    <td class="xl70" height="34.67" style="height: 26pt; text-align: center; border-right: 0.5pt solid windowtext" x:str>姓名</td>
                    <td class="xl71" colspan="2" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid windowtext">{{ vo.name }}</td>
                    <td class="xl73" x:str>性别</td>
                    <td class="xl74">{{ vo.gender }}</td>
                    <td class="xl73" x:str>出生年月</td>
                    <td class="xl74" colspan="2">{{ vo.birthDateStr }}</td>
                    <td class="xl73" x:str>家庭出身</td>
                    <td class="xl71" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid windowtext">
                        {{ vo.familyBackground || '无' }}
                    </td>
                    <td class="xl73" x:str>民族</td>
                    <td class="xl74">{{ vo.ethnicity }}</td>
                    <td class="xl73" x:str>政治面貌</td>
                    <td class="xl110" x:str>{{ vo.politicalStatus }}</td>
                    <td class="xl111" colspan="2" rowspan="4" style="border-right: 0.5pt solid #000000; border-bottom: 0.5pt solid #000000; padding: 10px" x:str>
                        <template v-if="vo.photoUrl">
                            <img style="width: 100%" :src="`apigw/xsgl/studentBasicInfo/download?dataField=idPhoto&nameField=photoUrl&id=${vo.basicInfoId}`" alt="" />
                        </template>
                    </td>
                </tr>
                <tr height="34.67" style="height: 26pt; mso-height-source: userset; mso-height-alt: 520">
                    <td class="xl75" height="34.67" style="height: 26pt; text-align: center" x:str>身体状况</td>
                    <td class="xl71" colspan="2" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid windowtext" x:num>
                        <!-- health -->
                        {{ vo.health || '无' }}
                    </td>
                    <td class="xl76" style="border-right: 0.5pt solid windowtext" x:str>籍贯</td>
                    <td class="xl77" colspan="3" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid windowtext" x:str>
                        {{ vo.nativePlace.split('-').join('') }}
                    </td>
                    <td class="xl76" style="border-right: 0.5pt solid windowtext" x:str>是否烈属</td>
                    <td class="xl71" colspan="2" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid windowtext">{{ vo.ifLs }}</td>
                    <td class="xl76" x:str>是否侨属</td>
                    <td class="xl93">{{ vo.ifQs }}</td>
                    <td class="xl76" x:str>受过何种奖励</td>
                    <td class="xl113" x:str>
                        {{ vo.reward || '无' }}
                    </td>
                </tr>
                <tr height="34.67" style="height: 26pt; mso-height-source: userset; mso-height-alt: 520">
                    <td class="xl75" height="69.33" rowspan="2" style="height: 52pt; border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid #000000; text-align: center" x:str>何时毕业于何中学</td>
                    <td class="xl80" colspan="3" rowspan="2" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid #000000">
                        {{ vo.graduationSchoolAndDate || '无' }}
                    </td>
                    <td class="xl83" rowspan="2" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid #000000" x:str>入技校时间</td>
                    <td class="xl80" colspan="2" rowspan="2" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid #000000">{{ vo.enrollmentDateStr }}</td>
                    <td class="xl83" rowspan="2" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid #000000" x:str>现在家庭详细地址</td>
                    <td class="xl80" colspan="3" rowspan="2" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid #000000">
                        {{ vo.familyAddress || '无' }}
                    </td>
                    <td class="xl76" x:str>电话</td>
                    <td class="xl115" colspan="2">{{ vo.mobilePhone }}</td>
                </tr>
                <tr height="34.67" style="height: 26pt; mso-height-source: userset; mso-height-alt: 520">
                    <td class="xl116" x:str>邮编</td>
                    <td class="xl108" colspan="2">{{ vo.postalCode }}</td>
                </tr>
                <tr height="34.67" style="height: 26pt; mso-height-source: userset; mso-height-alt: 520">
                    <td class="xl89" height="208" rowspan="6" style="height: 156pt; border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid windowtext" x:str>家庭主要成员及主要社会关系</td>
                    <td class="xl90" colspan="2" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid windowtext" x:str>姓名</td>
                    <td class="xl73" x:str>性别</td>
                    <td class="xl90" colspan="2" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid windowtext" x:str>与本人关系</td>
                    <td class="xl73" x:str>政治面貌</td>
                    <td class="xl90" colspan="6" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid windowtext" x:str>现在何处工作</td>
                    <td class="xl73" x:str>任何职务</td>
                    <td class="xl90" colspan="2" style="border-right: 0.5pt solid #000000; border-bottom: 0.5pt solid windowtext" x:str>备注</td>
                </tr>
                <tr v-for="item in studentFamilyMembers" :key="item.id" height="34.67" style="height: 26pt; mso-height-source: userset; mso-height-alt: 520">
                    <td class="xl92" colspan="2" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid windowtext">
                        {{ item.familyMemberName }}
                    </td>
                    <td class="xl92">
                        {{ item.sex }}
                    </td>
                    <td class="xl92" colspan="2" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid windowtext">
                        {{ item.relationship }}
                    </td>
                    <td class="xl93">
                        {{ item.politicalStatus }}
                    </td>
                    <td class="xl71" colspan="6" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid windowtext">
                        {{ item.workUnit }}
                    </td>
                    <td class="xl93">
                        {{ item.workPosition }}
                    </td>
                    <td class="xl71" colspan="2" style="border-right: 0.5pt solid #000000; border-bottom: 0.5pt solid windowtext">
                        {{ item.remark }}
                    </td>
                </tr>
                <tr height="34.67" style="height: 26pt; mso-height-source: userset; mso-height-alt: 520">
                    <td class="xl95" height="242.67" rowspan="7" style="height: 182pt; border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid #000000; border-left: 0.5pt solid #000000" x:str>学生操行评定及毕业鉴定</td>
                    <td class="xl96" colspan="4" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid windowtext" x:str>第一学年</td>
                    <td class="xl77" colspan="4" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid windowtext" x:str>第二学年</td>
                    <td class="xl77" colspan="4" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid windowtext" x:str>第三学年</td>
                    <td class="xl119" colspan="3" style="border-right: 0.5pt solid #000000; border-bottom: none" x:str>毕业鉴定</td>
                </tr>
                <tr height="34.67" style="height: 26pt; mso-height-source: userset; mso-height-alt: 520">
                    <td class="xl99" colspan="2" rowspan="5" style="border-right: 0.5pt solid windowtext; border-bottom: none; padding: 0">
                        <div style="height: 100%; width: 100%" class="evaluate_box">
                            <div class="item" style="text-align: center">第一学期</div>
                            <div style="height: calc(100% - 30px)">
                                <!-- <el-input v-if="canEdit" v-model="evaluateList[0].evaluate" type="textarea" size="mini" class="stu_card_textarea" resize="none" placeholder="请输入"></el-input> -->
                                <span class="comment">{{ evaluateList[0].evaluate || '' }}</span>
                            </div>
                        </div>
                    </td>
                    <td class="xl99" colspan="2" rowspan="5" style="border-right: 0.5pt solid windowtext; border-bottom: none; padding: 0">
                        <div style="height: 100%; width: 100%" class="evaluate_box">
                            <div class="item" style="text-align: center">第二学期</div>
                            <div style="height: calc(100% - 30px)">
                                <!-- <el-input v-if="canEdit" v-model="evaluateList[1].evaluate" type="textarea" size="mini" class="stu_card_textarea" resize="none" placeholder="请输入"></el-input> -->
                                <span>{{ evaluateList[1].evaluate || '' }}</span>
                            </div>
                        </div>
                    </td>
                    <td class="xl99" colspan="2" rowspan="5" style="border-right: 0.5pt solid windowtext; border-bottom: none; padding: 0">
                        <div style="height: 100%; width: 100%" class="evaluate_box">
                            <div class="item" style="text-align: center">第三学期</div>
                            <div style="height: calc(100% - 30px)">
                                <!-- <el-input v-if="canEdit" v-model="evaluateList[2].evaluate" type="textarea" size="mini" class="stu_card_textarea" resize="none" placeholder="请输入"></el-input> -->
                                <span>{{ evaluateList[2].evaluate || '' }}</span>
                            </div>
                        </div>
                    </td>
                    <td class="xl99" colspan="2" rowspan="5" style="border-right: 0.5pt solid windowtext; border-bottom: none; padding: 0">
                        <div style="height: 100%; width: 100%" class="evaluate_box">
                            <div class="item" style="text-align: center">第四学期</div>
                            <div style="height: calc(100% - 30px)">
                                <!-- <el-input v-if="canEdit" v-model="evaluateList[3].evaluate" type="textarea" size="mini" class="stu_card_textarea" resize="none" placeholder="请输入"></el-input> -->
                                <span>{{ evaluateList[3].evaluate || '' }}</span>
                            </div>
                        </div>
                    </td>
                    <td class="xl99" colspan="2" rowspan="5" style="border-right: 0.5pt solid windowtext; border-bottom: none; padding: 0">
                        <div style="height: 100%; width: 100%" class="evaluate_box">
                            <div class="item" style="text-align: center">第五学期</div>
                            <div style="height: calc(100% - 30px)">
                                <!-- <el-input v-if="canEdit" v-model="evaluateList[4].evaluate" type="textarea" size="mini" class="stu_card_textarea" resize="none" placeholder="请输入"></el-input> -->
                                <span>{{ evaluateList[4].evaluate || '' }}</span>
                            </div>
                        </div>
                    </td>
                    <td class="xl99" colspan="2" rowspan="5" style="border: none; padding: 0">
                        <div style="height: 100%; width: 100%" class="evaluate_box">
                            <div class="item" style="text-align: center">第六学期</div>
                            <div style="height: calc(100% - 30px)">
                                <!-- <el-input v-if="canEdit" v-model="evaluateList[5].evaluate" type="textarea" size="mini" class="stu_card_textarea" resize="none" placeholder="请输入"></el-input> -->
                                <span>{{ evaluateList[5].evaluate || '' }}</span>
                            </div>
                        </div>
                    </td>
                    <!-- 毕业鉴定 -->
                    <td class="xl122" colspan="3" rowspan="5" style="border-right: 0.5pt solid #000000; border-bottom: none" x:str>
                        <el-input v-if="canEdit" v-model="evaluateList[6].evaluate" type="textarea" size="mini" class="stu_card_textarea" resize="none" placeholder="请输入"></el-input>
                        <span v-else>{{ evaluateList[6].evaluate || '' }}</span>
                    </td>
                </tr>
                <tr height="34.67" style="height: 26pt; mso-height-source: userset; mso-height-alt: 520"></tr>
                <tr height="34.67" style="height: 26pt; mso-height-source: userset; mso-height-alt: 520"></tr>
                <tr height="34.67" style="height: 26pt; mso-height-source: userset; mso-height-alt: 520"></tr>
                <tr height="34.67" style="height: 26pt; mso-height-source: userset; mso-height-alt: 520"></tr>
                <tr height="34.67" style="height: 26pt; mso-height-source: userset; mso-height-alt: 520">
                    <td class="xl104" colspan="2" style="padding-left: 16px; text-align: left; border-right: 0.5pt solid #000000; border-bottom: 0.5pt solid #000000" x:str>班主任盖章</td>
                    <td class="xl104" colspan="2" style="padding-left: 16px; text-align: left; border-right: 0.5pt solid #000000; border-bottom: 0.5pt solid #000000" x:str>班主任盖章</td>
                    <td class="xl104" colspan="2" style="padding-left: 16px; text-align: left; border-right: 0.5pt solid #000000; border-bottom: 0.5pt solid #000000" x:str>班主任盖章</td>
                    <td class="xl104" colspan="2" style="padding-left: 16px; text-align: left; border-right: 0.5pt solid #000000; border-bottom: 0.5pt solid #000000" x:str>班主任盖章</td>
                    <td class="xl104" colspan="2" style="padding-left: 16px; text-align: left; border-right: 0.5pt solid #000000; border-bottom: 0.5pt solid #000000" x:str>班主任盖章</td>
                    <td class="xl104" colspan="2" style="padding-left: 16px; text-align: left; border-right: none; border-bottom: 0.5pt solid #000000" x:str>班主任盖章</td>
                    <td class="xl133" colspan="3" style="padding-left: 16px; text-align: left; border-right: 0.5pt solid #000000; border-bottom: 0.5pt solid #000000" x:str>学校盖章</td>
                </tr>
                <tr height="34.67" style="height: 26pt; mso-height-source: userset; mso-height-alt: 520">
                    <td class="xl106" height="69.33" rowspan="2" style="height: 52pt; border-right: 0.5pt solid #000000; border-bottom: 0.5pt solid #000000" x:str>奖惩记录</td>
                    <td class="xl107" colspan="15" rowspan="2" style="border-right: 0.5pt solid #000000; border-bottom: 0.5pt solid #000000">
                        <el-input v-if="canEdit" v-model="evaluateRecord" type="textarea" size="mini" class="stu_card_textarea" resize="none" placeholder="请输入"></el-input>
                        <span v-else>{{ evaluateRecord || '' }}</span>
                    </td>
                </tr>
                <tr height="34.67" style="height: 26pt; mso-height-source: userset; mso-height-alt: 520"></tr>
                <tr height="34.67" style="height: 26pt; mso-height-source: userset; mso-height-alt: 520">
                    <td class="xl67" height="34.67" colspan="16" style="height: 26pt; border: none; text-align: left" x:str>注：此卡由学校填写一式二份，一份作为学生档案材料，一份留校存档。</td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
const moment = require('moment')
import { initBasicCardData } from './help'
export default {
    filters: {},
    props: {
        vo: {
            type: Object,
            default: function () {
                return {}
            }
        },
        canEdit: {
            type: Number,
            default: 1
        },
        moduleInfo: {
            type: Object,
            default: function () {
                return {}
            }
        }
    },
    data: function () {
        return {
            height: 900,
            studentFamilyMembers: [], //家庭成员
            evaluateList: [], // 评定
            evaluateRecord: '' //奖惩记录
        }
    },
    computed: {},
    watch: {
        vo: function (val) {
            this.initData()
            this.setFamilyMembers()
        }
    },
    created: function () {
        this.initData()
        this.setFamilyMembers()
    },
    beforeDestroy: function () {},
    mounted: function () {
        console.log('表单内容', this.vo)

        // let _basicBox = document.getElementById('basicBox')
        // this.height = _basicBox.offsetHeight + 100
        console.log('this.height', this.height)
    },
    methods: {
        initData() {
            this.evaluateRecord = this.vo.evaluateRecord
            const { evaluateList } = this.vo
            if (evaluateList === null) {
                this.evaluateList = initBasicCardData().evaluateList
            } else {
                this.evaluateList = JSON.parse(evaluateList)
            }
        },
        setFamilyMembers() {
            let list = []
            list = JSON.parse(this.vo.familyMember)
            if (list.length) {
                if (list.length < 5) {
                    let length = list.length
                    let familyList = initBasicCardData().familyList
                    for (let i = 0; i < 5 - length; i++) {
                        list.push(familyList[i])
                    }
                    list.forEach((item) => {
                        // item.workPosition = ''
                        item.remark = ''
                    })
                } else if (list.length > 5) {
                    list = list.slice(0, 5)
                }
            } else {
                list = initBasicCardData().familyList
            }
            this.studentFamilyMembers = list
        }
    }
}
</script>

<style scoped lang="scss">
#basicBox {
    .stu_card_input {
        width: 100%;
        padding: 0 3px;

        /deep/.el-input__inner {
            height: 32px;
            line-height: 32px;
            border: none;
            border-bottom: 1px solid #ccc;
            border-radius: unset;
        }
    }

    .stu_card_textarea {
        width: 100%;
        height: 100%;
        padding: 3px;

        /deep/.el-textarea__inner {
            height: 100%;
        }
    }
}

.evaluate_box {
    height: 100%;
    width: 100%;

    .item {
        height: 30px;
        line-height: 30px;
        border-bottom: 1px solid #999;
        font-size: 10pt;
        color: #000;
        font-weight: 500;
    }
}

tr {
    mso-height-source: auto;
    mso-ruby-visibility: none;
}

col {
    mso-width-source: auto;
    mso-ruby-visibility: none;
}

br {
    mso-data-placement: same-cell;
}

td {
    mso-style-parent: style0;
    padding-top: 1px;
    padding-right: 1px;
    padding-left: 1px;
    mso-ignore: padding;
    mso-number-format: 'General';
    text-align: general;
    vertical-align: middle;
    white-space: nowrap;
    mso-rotate: 0;
    mso-pattern: auto;
    mso-background-source: auto;
    color: windowtext;
    font-size: 12pt;
    font-weight: 400;
    font-style: normal;
    text-decoration: none;
    font-family: 宋体;
    mso-generic-font-family: auto;
    mso-font-charset: 134;
    border: none;
    mso-protection: locked visible;
}

.xl65 {
    mso-style-parent: style0;
    mso-pattern: auto none;
    background: #ffffff;
    mso-font-charset: 134;
}

.xl66 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 22pt;
    font-family: Microsoft YaHei;
    mso-generic-font-family: swiss;
    mso-font-charset: 134;
}

.xl67 {
    mso-style-parent: style0;
    text-align: left;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-generic-font-family: swiss;
    mso-font-charset: 134;
}

.xl68 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-font-charset: 134;
}

.xl69 {
    mso-style-parent: style0;
    text-align: left;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-generic-font-family: swiss;
    mso-font-charset: 134;
    border-left: 0.5pt solid windowtext;
    border-top: 0.5pt solid #000000;
    border-right: 0.5pt solid windowtext;
    border-bottom: 0.5pt solid windowtext;
}

.xl70 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-font-charset: 134;
    border-left: 0.5pt solid windowtext;
    border-top: 0.5pt solid #000000;
    border-bottom: 0.5pt solid windowtext;
}

.xl71 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-font-charset: 134;
    border-top: 0.5pt solid #000000;
    border-right: 0.5pt solid windowtext;
    border-bottom: 0.5pt solid windowtext;
}

.xl72 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-generic-font-family: swiss;
    mso-font-charset: 134;
    border-left: 0.5pt solid windowtext;
    border-top: 0.5pt solid #000000;
    border-right: 0.5pt solid windowtext;
    border-bottom: 0.5pt solid windowtext;
}

.xl73 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-font-charset: 134;
    border-left: 0.5pt solid windowtext;
    border-top: 0.5pt solid #000000;
    border-right: 0.5pt solid windowtext;
    border-bottom: 0.5pt solid windowtext;
}

.xl74 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-generic-font-family: swiss;
    mso-font-charset: 134;
    border: 0.5pt solid windowtext;
}

.xl75 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-generic-font-family: swiss;
    mso-font-charset: 134;
    border: 0.5pt solid windowtext;
}

.xl76 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-generic-font-family: swiss;
    mso-font-charset: 134;
    border-left: 0.5pt solid windowtext;
    border-top: 0.5pt solid windowtext;
    border-bottom: 0.5pt solid windowtext;
}

.xl77 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-font-charset: 134;
    border-top: 0.5pt solid windowtext;
    border-bottom: 0.5pt solid windowtext;
}

.xl78 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-font-charset: 134;
    border-top: 0.5pt solid windowtext;
    border-right: 0.5pt solid windowtext;
    border-bottom: 0.5pt solid windowtext;
}

.xl79 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-font-charset: 134;
    border-left: 0.5pt solid windowtext;
    border-top: 0.5pt solid windowtext;
}

.xl80 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-font-charset: 134;
    border-top: 0.5pt solid windowtext;
}

.xl81 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-font-charset: 134;
    border-top: 0.5pt solid windowtext;
    border-right: 0.5pt solid windowtext;
}

.xl82 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-generic-font-family: swiss;
    mso-font-charset: 134;
    border-left: 0.5pt solid windowtext;
    border-top: 0.5pt solid windowtext;
    border-right: 0.5pt solid windowtext;
}

.xl83 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-font-charset: 134;
    border-left: 0.5pt solid windowtext;
    border-top: 0.5pt solid windowtext;
    border-right: 0.5pt solid windowtext;
    border-bottom: 0.5pt solid #000000;
}

.xl84 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-font-charset: 134;
    border-left: 0.5pt solid windowtext;
    border-bottom: 0.5pt solid #000000;
}

.xl85 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-font-charset: 134;
    border-bottom: 0.5pt solid #000000;
}

.xl86 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-font-charset: 134;
    border-right: 0.5pt solid windowtext;
    border-bottom: 0.5pt solid #000000;
}

.xl87 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-font-charset: 134;
    border-left: 0.5pt solid windowtext;
    border-right: 0.5pt solid windowtext;
    border-bottom: 0.5pt solid #000000;
}

.xl88 {
    mso-style-parent: style0;
    text-align: left;
    white-space: normal;
    layout-flow: vertical;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-generic-font-family: swiss;
    mso-font-charset: 134;
    border-left: 0.5pt solid windowtext;
    border-top: 0.5pt solid #000000;
    border-right: 0.5pt solid windowtext;
}

.xl89 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-generic-font-family: swiss;
    mso-font-charset: 134;
    border-left: 0.5pt solid windowtext;
    border-top: 0.5pt solid #000000;
    border-bottom: 0.5pt solid windowtext;
}

.xl90 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    layout-flow: vertical;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-font-charset: 134;
    border-left: 0.5pt solid windowtext;
    border-right: 0.5pt solid windowtext;
}

.xl91 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-font-charset: 134;
    border-left: 0.5pt solid windowtext;
    border-top: 0.5pt solid windowtext;
    border-bottom: 0.5pt solid windowtext;
}

.xl92 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-font-charset: 134;
    border: 0.5pt solid windowtext;
}

.xl93 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    layout-flow: vertical;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-font-charset: 134;
    border-left: 0.5pt solid windowtext;
    border-right: 0.5pt solid windowtext;
    border-bottom: 0.5pt solid windowtext;
}

.xl94 {
    mso-style-parent: style0;
    text-align: left;
    white-space: normal;
    layout-flow: vertical;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-generic-font-family: swiss;
    mso-font-charset: 134;
    border: 0.5pt solid windowtext;
}

.xl95 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-generic-font-family: swiss;
    mso-font-charset: 134;
    border-top: 0.5pt solid windowtext;
}

.xl96 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-font-charset: 134;
    border-top: 0.5pt solid windowtext;
}

.xl97 {
    mso-style-parent: style0;
    text-align: left;
    white-space: normal;
    layout-flow: vertical;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 11pt;
    font-weight: 700;
    font-family: Microsoft YaHei;
    mso-font-charset: 134;
    border-left: 0.5pt solid windowtext;
    border-top: 0.5pt solid windowtext;
    border-bottom: 0.5pt solid windowtext;
}

.xl98 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 11pt;
    font-weight: 700;
    font-family: Microsoft YaHei;
    mso-font-charset: 134;
    border-left: 0.5pt solid windowtext;
    border-top: 0.5pt solid windowtext;
}

.xl99 {
    mso-style-parent: style0;
    // text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 11pt;
    font-weight: 700;
    font-family: Microsoft YaHei;
    mso-font-charset: 134;
    border-top: 0.5pt solid windowtext;
    border-right: 0.5pt solid windowtext;
}
.comment {
    text-align: left;
}

.xl100 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 11pt;
    font-weight: 700;
    font-family: Microsoft YaHei;
    mso-font-charset: 134;
    border-left: 0.5pt solid windowtext;
}

.xl101 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 11pt;
    font-weight: 700;
    font-family: Microsoft YaHei;
    mso-font-charset: 134;
    border-right: 0.5pt solid windowtext;
}

.xl102 {
    mso-style-parent: style0;
    text-align: left;
    white-space: normal;
    layout-flow: vertical;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 11pt;
    font-weight: 700;
    font-family: Microsoft YaHei;
    mso-font-charset: 134;
    border-left: 0.5pt solid windowtext;
    border-top: 0.5pt solid windowtext;
    border-right: 0.5pt solid windowtext;
    border-bottom: 0.5pt solid #000000;
}

.xl103 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 11pt;
    font-weight: 700;
    font-family: Microsoft YaHei;
    mso-generic-font-family: swiss;
    mso-font-charset: 134;
    border-bottom: 0.5pt solid #000000;
}

.xl104 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 11pt;
    font-weight: 700;
    font-family: Microsoft YaHei;
    mso-font-charset: 134;
    border-right: 0.5pt solid #000000;
    border-bottom: 0.5pt solid #000000;
}

.xl105 {
    mso-style-parent: style0;
    text-align: left;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-generic-font-family: swiss;
    mso-font-charset: 134;
    border-left: 0.5pt solid windowtext;
    border-top: 0.5pt solid #000000;
    border-right: 0.5pt solid #000000;
    border-bottom: 0.5pt solid windowtext;
}

.xl106 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-font-charset: 134;
    border-left: 0.5pt solid #000000;
    border-top: 0.5pt solid #000000;
    border-right: 0.5pt solid windowtext;
    border-bottom: 0.5pt solid windowtext;
}

.xl107 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-font-charset: 134;
    border-left: 0.5pt solid windowtext;
    border-top: 0.5pt solid windowtext;
    border-right: 0.5pt solid #000000;
    border-bottom: 0.5pt solid #000000;
}

.xl108 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-font-charset: 134;
    border-left: 0.5pt solid #000000;
    border-top: 0.5pt solid windowtext;
    border-right: 0.5pt solid windowtext;
    border-bottom: 0.5pt solid #000000;
}

.xl109 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-generic-font-family: swiss;
    mso-font-charset: 134;
}

.xl110 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-generic-font-family: swiss;
    mso-font-charset: 134;
    border-left: 0.5pt solid windowtext;
    border-top: 0.5pt solid #000000;
    border-right: 0.5pt solid #000000;
    border-bottom: 0.5pt solid windowtext;
}

.xl111 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-generic-font-family: swiss;
    mso-font-charset: 134;
    border-left: 0.5pt solid #000000;
    border-top: 0.5pt solid #000000;
    border-right: 0.5pt solid windowtext;
    border-bottom: 0.5pt solid windowtext;
}

.xl112 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-font-charset: 134;
    border-left: 0.5pt solid windowtext;
    border-top: 0.5pt solid #000000;
    border-right: 0.5pt solid #000000;
    border-bottom: 0.5pt solid windowtext;
}

.xl113 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-generic-font-family: swiss;
    mso-font-charset: 134;
    border-left: 0.5pt solid windowtext;
    border-top: 0.5pt solid windowtext;
    border-right: 0.5pt solid #000000;
    border-bottom: 0.5pt solid windowtext;
}

.xl114 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-font-charset: 134;
    border-left: 0.5pt solid #000000;
    border-top: 0.5pt solid windowtext;
    border-right: 0.5pt solid windowtext;
    border-bottom: 0.5pt solid windowtext;
}

.xl115 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-font-charset: 134;
    border-left: 0.5pt solid windowtext;
    border-top: 0.5pt solid windowtext;
    border-right: 0.5pt solid #000000;
    border-bottom: 0.5pt solid windowtext;
}

.xl116 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-generic-font-family: swiss;
    mso-font-charset: 134;
    border-left: 0.5pt solid windowtext;
    border-top: 0.5pt solid windowtext;
    border-right: 0.5pt solid windowtext;
    border-bottom: 0.5pt solid #000000;
}

.xl117 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-font-charset: 134;
    border-top: 0.5pt solid #000000;
    border-bottom: 0.5pt solid windowtext;
}

.xl118 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-font-charset: 134;
    border-top: 0.5pt solid #000000;
    border-right: 0.5pt solid #000000;
    border-bottom: 0.5pt solid windowtext;
}

.xl119 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-generic-font-family: swiss;
    mso-font-charset: 134;
    border-left: 0.5pt solid windowtext;
    border-top: 0.5pt solid windowtext;
}

.xl120 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-font-charset: 134;
    border-top: 0.5pt solid windowtext;
    border-right: 0.5pt solid #000000;
}

.xl121 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 11pt;
    font-weight: 700;
    font-family: Microsoft YaHei;
    mso-font-charset: 134;
    border-top: 0.5pt solid windowtext;
}

.xl122 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 11pt;
    font-weight: 700;
    font-family: Microsoft YaHei;
    mso-generic-font-family: swiss;
    mso-font-charset: 134;
    border-left: 0.5pt solid windowtext;
    border-top: 0.5pt solid windowtext;
}

.xl123 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 11pt;
    font-weight: 700;
    font-family: Microsoft YaHei;
    mso-font-charset: 134;
    border-top: 0.5pt solid windowtext;
}

.xl124 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 11pt;
    font-weight: 700;
    font-family: Microsoft YaHei;
    mso-font-charset: 134;
    border-top: 0.5pt solid windowtext;
    border-right: 0.5pt solid #000000;
}

.xl125 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 11pt;
    font-weight: 700;
    font-family: Microsoft YaHei;
    mso-font-charset: 134;
}

.xl126 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 11pt;
    font-weight: 700;
    font-family: Microsoft YaHei;
    mso-font-charset: 134;
    border-left: 0.5pt solid windowtext;
}

.xl127 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 11pt;
    font-weight: 700;
    font-family: Microsoft YaHei;
    mso-font-charset: 134;
}

.xl128 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 11pt;
    font-weight: 700;
    font-family: Microsoft YaHei;
    mso-font-charset: 134;
    border-right: 0.5pt solid #000000;
}

.xl129 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 11pt;
    font-weight: 700;
    font-family: Microsoft YaHei;
    mso-font-charset: 134;
    border-left: 0.5pt solid windowtext;
}

.xl130 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 11pt;
    font-weight: 700;
    font-family: Microsoft YaHei;
    mso-font-charset: 134;
}

.xl131 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 11pt;
    font-weight: 700;
    font-family: Microsoft YaHei;
    mso-font-charset: 134;
    border-right: 0.5pt solid #000000;
}

.xl132 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 11pt;
    font-weight: 700;
    font-family: Microsoft YaHei;
    mso-font-charset: 134;
    border-bottom: 0.5pt solid #000000;
}

.xl133 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 11pt;
    font-weight: 700;
    font-family: Microsoft YaHei;
    mso-generic-font-family: swiss;
    mso-font-charset: 134;
    border-left: 0.5pt solid windowtext;
    border-bottom: 0.5pt solid #000000;
}
</style>
